<template>
  <v-app>
    <PartnerAnalysesCard
      v-for="partner in partners"
      :key="partner.id"
      :partner="partner"
      :use-banner="partner.discount > 0"
      data-qa="partner_card"
    />
    <LaboratoriesList @click:lab="handleClickLab" />
    <div id="use-vue-base-dialog" />
  </v-app>
</template>

<script setup lang="ts">
import { onBeforeMount } from 'vue'
import {
  Laboratory,
  Partner,
  Town,
} from 'www/vue_components/common/Analyses/types'
import { CartButtonEnum } from 'www/vue_components/common/Analyses/enums'
import LaboratoriesList from 'www/vue_components/common/Analyses/components/LaboratoriesList/LaboratoriesList.vue'
import PartnerAnalysesCard from 'www/vue_components/common/Analyses/pages/AnalysesListPage/components/PartnerAnalysesCard.vue'
import useCartContentStore from 'www/vue_components/common/Analyses/stores/useCartContentStore'
import useCommonAnalysesStore from 'www/vue_components/common/Analyses/stores/useCommonStore'
import useLabsStore from 'www/vue_components/common/Analyses/components/LaboratoriesList/stores/useLabsStore'

const props = defineProps<{
  partners: Partner[]
  town: Town
  analysesCountInCart: number
}>()

const { setCartButtonType } = useCartContentStore()
const labsStore = useLabsStore()
const { setTown } = useCommonAnalysesStore()

const cartContentStore = useCartContentStore()

onBeforeMount(() => {
  setCartButtonType(CartButtonEnum.redirect)
  setTown(props.town)

  cartContentStore.setTotalAnalysesInCartCount(props.analysesCountInCart)

  labsStore.updateRequestLabData({
    partnerSlug: props.partners[0].slug,
    townTranslit: props.town.translit,
  })
})

function handleClickLab(payload: { id: number, lpu: Laboratory }) {
  window.location.assign(`/${payload.lpu.town.translit}/analyses/${props.partners[0].slug}/?lpu_id=${payload.lpu.id}`)
}
</script>
